import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Image, Button } from 'reaxl';
class DealerDiffCTA extends PureComponent {
  render() {
    const {
      className,
      label,
      tile,
      onDealerDiffCTAClick,
      ...rest
    } = this.props;
    if (!label || !onDealerDiffCTAClick) {
      return null;
    }
    const componentKey = 'dealerDiffCTA';
    if (tile && tile.src) {
      return /*#__PURE__*/React.createElement(Image, Object.assign({
        key: componentKey,
        className: className,
        alt: label
      }, rest, tile, {
        height: 44,
        onClick: onDealerDiffCTAClick
      }));
    }
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      key: componentKey,
      "data-cmp": "dealerDiffCTA",
      className: className
    }, rest, {
      onClick: onDealerDiffCTAClick,
      bsStyle: "text"
    }), label);
  }
}
export default DealerDiffCTA;